import React, { Component } from 'react';
import { Field, reduxForm, Form, change, isDirty } from 'redux-form';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import { MenuItem } from 'material-ui/Menu';
import { connect } from 'react-redux';
import { Link, Prompt } from 'react-router-dom';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';

import Dialog from 'material-ui/Dialog';
import DialogActions from 'material-ui/Dialog/DialogActions';
import DialogContent from 'material-ui/Dialog/DialogContent';
import DialogContentText from 'material-ui/Dialog/DialogContentText';
import DialogTitle from 'material-ui/Dialog/DialogTitle';
import Paper from 'material-ui/Paper';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Close from 'material-ui-icons/Cancel';

import renderTextField from '../../../helpers/RenderTextFiledWithDiv';
import renderSelectField from '../../../helpers/RenderSelectField';
import renderDatePicker from '../../../helpers/RenderDatePicker';
import renderCheckBoxGroup from '../../../helpers/RenderCheckBoxGroup';
import validationHelper from '../../../helpers/ValidationHelper';
import AutoComplete from '../../../helpers/AutoComplete';
import RenderDialog from '../../../helpers/RenderDialog';

import Layout from '../../Layout';
import addEditBillingInformation from '../../../actions/addEditBillingInformation';
import search from '../../../actions/searchByAttribute';
import getReportTypes from '../../../actions/getReportTypes';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  content: {
    flex: '1 0 auto',
  },
  paperStyle: {
    width: '70%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '12vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 350,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  radioGroup: {
    marginTop: '2%',
    marginLeft: '12%',
    textAlign: 'left'
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  headerTitleStyle: {
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  addIcon: {
    position: 'absolute',
    margin: '1%'
  }
});

const validate = (values) => {
  const errors = validationHelper.validateRequired(['customer', 'rateTypeId',
    'startDate', 'billNoHits', 'billNoHistory', 'billInvalidVINs'], values);
  if (values.billingRate && !values.reportTypeId) {
    errors.reportTypeId = 'Required';
  }
  if (values.rateTypeId && values.rateTypeId !== '492eb77d-909c-48f9-b3d8-ee9d8555dd67' && !values.billingRate) {
    errors.billingRate = 'Required';
  }
  if (values.rateTypeId && values.rateTypeId !== '492eb77d-909c-48f9-b3d8-ee9d8555dd67' && !values.gracePeriod) {
    errors.gracePeriod = 'Required';
  }
  if (values.gracePeriod && !validationHelper.validateNumber(values.gracePeriod)) {
    errors.gracePeriod = 'Please enter a valid number';
  }
  if (values.billingRate && !validationHelper.validateCurrency(values.billingRate)) {
    errors.billingRate = 'Please enter a valid amount';
  }
  if (values.reportTypeMin && !validationHelper.validateCurrency(values.reportTypeMin)) {
    errors.reportTypeMin = 'Please enter a valid amount';
  }
  if (values.reportTypeMax && !validationHelper.validateCurrency(values.reportTypeMax)) {
    errors.reportTypeMax = 'Please enter a valid amount';
  }
  if (values.startDate && !validationHelper.validateDate(values.startDate)) {
    errors.startDate = 'Please enter a valid date';
  }
  if (values.endDate && !validationHelper.validateDate(values.endDate)) {
    errors.endDate = 'Please enter a valid date';
  }
  if (errors) {
    return errors;
  }
};

class AddEditBillingInformation extends Component {
  state = {
    contractRateId: '',
    showOwnership: false,
    reports: [],
    open: false,
    reportNames: [],
    customerName: '',
    reportTypeId: '',
    vhrOwnership: '',
    reportSelected: '',
    buttonColor: '#002053',
    redirect: false,
    formSaved: false
  };

  componentDidMount() {
    this.props.actions.getCustomerBillingInfo(this.props.match.params.id, this.props.data.config, this);
    this.props.actions.getReportTypes(this.props.data.config, this);
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  handleConfirmSaved = () => {
    return this.props.data.billingInfo.saved;
  }

  handleSave = (event) => {
    this.setState({ buttonColor: '#ddd' });
    const contractRate = {
      reportTypeId: this.state.reportSelected,
      reportTypeMin: (event.reportTypeMin) ? Number.parseFloat(event.reportTypeMin.replace(',', '')).toFixed(2) : null,
      reportTypeMax: (event.reportTypeMax) ? Number.parseFloat(event.reportTypeMax.replace(',', '')).toFixed(2) : null,
      rateTypeId: event.rateTypeId,
      startDate: event.startDate,
      endDate: (event.endDate) ? event.endDate : '12/31/9999',
      billInvalidVINs: event.billInvalidVINs === 'Yes',
      billNoHits: event.billNoHits === 'Yes',
      billNoHistory: event.billNoHistory === 'Yes',
      isActive: true
    };

    if (event.gracePeriod) {
      contractRate.gracePeriod = event.gracePeriod;
    } else {
      contractRate.gracePeriod = null;
    }

    if (event.billingRate) {
      contractRate.billingRate = Number.parseFloat(event.billingRate.replace(',', '')).toFixed(2);
    } else {
      contractRate.billingRate = null;
    }

    if (this.state.contractRateId) {
      contractRate.contractRateId = this.state.contractRateId;
    }

    if (this.props.match.params.id) {
      contractRate.customerId = this.props.match.params.id;
    }

    this.props.actions.addEditBillingInformation(contractRate, this.props.data.config, this);
  };

  handleCheckChange = (event) => {
    this.props.dispatch(change('AddEditBillingInformationForm', event.target.name, event.target.value));
  };

  handleCloseYes = () => {
    this.setState({ open: false, formSaved: false });
  };

  handleCloseNo = () => {
    this.props.history.push('/customers');
    this.setState({ open: false });
  };

  render() {
    this.props.change('customerName', this.state.customerName);
    this.props.change('reportWithOwnership', ((this.state.vhrOwnership) ? 'Yes' : 'No'));

    const { classes, handleSubmit } = this.props;
    const optionsList = [{ id: 1, label: 'Yes' }, { id: 2, label: 'No' }];

    const showWithOwnershipRadioButtons = (event) => {

      if (this.props.data.billingInfo &&
        this.props.data.billingInfo.contractRateResult &&
        this.props.data.billingInfo.contractRateResult.contractrates &&
        Array.isArray(this.props.data.billingInfo.contractRateResult.contractrates.data)) {
        const result = this.props.data.billingInfo.contractRateResult.contractrates.data
          .find(x => x.reportTypeId === event);

        if (result) {
          this.props.change('billNoHits', result.billNoHits === true || result.billNoHits === 'Yes' ? 'Yes' : 'No');
          this.props.change('billInvalidVINs', result.billInvalidVINs === true || result.billInvalidVINs === 'Yes' ? 'Yes' : 'No');
          this.props.change('billNoHistory', result.billNoHistory === true || result.billNoHistory === 'Yes' ? 'Yes' : 'No');
          this.props.change('gracePeriod', result.gracePeriod);
          this.props.change('startDate', new Date(result.startDate).toISOString().split('T')[0]);
          this.props.change('endDate', (result.endDate && result.endDate !== '12/31/9999' && result.endDate !== '9999-12-31') ? new Date(result.endDate).toISOString().split('T')[0] : '');
          this.props.change('billingRate', Number.parseFloat(result.billingRate * 1.00).toFixed(2).toString());
          this.props.change('reportTypeMin', (result.reportTypeMin) ? Number.parseFloat(result.reportTypeMin * 1.00).toFixed(2).toString() : '');
          this.props.change('reportTypeMax', (result.reportTypeMax) ? Number.parseFloat(result.reportTypeMax * 1.00).toFixed(2) : '');
          this.setState({ contractRateId: result.contractRateId });
        } else {
          this.props.change('billNoHits', 'No');
          this.props.change('billInvalidVINs', 'Yes');
          this.props.change('gracePeriod', '');
          this.props.change('billNoHistory', 'Yes');
          this.props.change('startDate', '');
          this.props.change('endDate', '');
          this.props.change('billingRate', '');
          this.props.change('reportTypeMin', '');
          this.props.change('reportTypeMax', '');
          this.setState({ contractRateId: '' });
        }
      }

      if (event === '0dae3cc1-27d1-4629-8927-532441961779' && this.state.vhrOwnership) {
        this.setState({ showOwnership: true });
      } else {
        this.setState({ showOwnership: false });
      }
    };

    let reportList = [];
    this.state.reports.filter((reportType) => {
      this.state.reportNames.forEach((repName) => {
        if (reportType.methodId === repName) {
          reportList.push({ value: reportType.enum, label: reportType.displayName });
        }
      });
    });

    reportList.sort((a, b) => {
      if (a.label.toLowerCase() > b.label.toLowerCase()) {
        return 1;
      }
      if (a.label.toLowerCase() < b.label.toLowerCase()) {
        return -1;
      }
      return 0;
    })

    const handleReportSelection = (value) => {
      if (value) {
        this.setState({ reportSelected: value });
      }
    }

    const selectedSuggestions = this.state.reportSelected;

    const form = (<Form onSubmit={handleSubmit(this.handleSave)}>
      <Card className={classes.card} xs={12} sm={6}>
        <CardContent className={classes.content}>
          <Field
            disabled
            name="customerName"
            component={renderTextField}
            label="Customer"
            className={classes.textField}
            divClassName={classes.marginStyle}
          />
          <div className="AutoComplete-div editBillingAutoComplete">
            {/* <div style={{ width: 'auto', margin: '0 auto', paddingTop: '2%' }}> */}
            <AutoComplete
              onChange={(e) => { handleReportSelection(e); showWithOwnershipRadioButtons(e); }}
              selectedSuggestions={selectedSuggestions}
              suggestions={reportList}
              name="reportTypeId"
              label="Select a Report Type"
              placeholder="Select a Report Type"
            />
          </div>
          {(this.state.showOwnership) ?
            (<Field
              disabled
              name="reportWithOwnership"
              component={renderTextField}
              label="With Ownership?"
              className={classes.textField}
              divClassName={classes.marginStyle}
            />) : null}
          <Field
            name="billingRate"
            component={renderTextField}
            label="Billing Rate"
            className={classes.textField}
            divClassName={classes.marginStyle}
          />
          <Field
            name="gracePeriod"
            component={renderTextField}
            label="Grace Period"
            className={classes.textField}
            divClassName={classes.marginStyle}
          />
          <Field
            name="reportTypeMin"
            component={renderTextField}
            label="Report Type Min"
            className={classes.textField}
            divClassName={classes.marginStyle}
          />
          <Field
            name="reportTypeMax"
            component={renderTextField}
            label="Report Type Max"
            className={classes.textField}
            divClassName={classes.marginStyle}
          />
        </CardContent>
        <CardContent className={classes.content}>
          <div className="AutoComplete-div-BillingType">
            <Field
              name="rateTypeId"
              component={renderSelectField}
              label="Billing Type"
              className={classes.textField}
              divClassName={classes.formControl}
            >
              <MenuItem value="492eb77d-909c-48f9-b3d8-ee9d8555dd67">Flat Invoice</MenuItem>
              <MenuItem value="309acdbb-a873-45bc-b2f4-96e4b880d70e">Flat Transactional</MenuItem>
              <MenuItem value="ed5f8d40-7f83-490b-8085-013fc2517d21">Tiered Transactional</MenuItem>
            </Field>
          </div>
          <Field
            name="startDate"
            component={renderDatePicker}
            label="Start Date"
            className={classes.textField}
            divClassName={classes.marginStyle1}
          />
          <Field
            name="endDate"
            component={renderDatePicker}
            label="End Date"
            className={classes.textField}
            divClassName={classes.marginStyle1}
          />
          <Field
            name="billInvalidVINs"
            component={renderCheckBoxGroup}
            options={optionsList}
            className={classes.radioGroup}
            label="Bill Invalid VINs?"
            handleCheckChange={this.handleCheckChange}
          />
          <Field
            name="billNoHits"
            component={renderCheckBoxGroup}
            options={optionsList}
            className={classes.radioGroup}
            label="Bill No Hits?"
            handleCheckChange={this.handleCheckChange}
          />
          <Field
            name="billNoHistory"
            component={renderCheckBoxGroup}
            options={optionsList}
            className={classes.radioGroup}
            label="Bill No History?"
            handleCheckChange={this.handleCheckChange}
          />
        </CardContent>
      </Card >
      <div className={classes.buttonStyle}>
        <Button variant="raised"
          style={((this.props.valid) && !this.props.submitting) ? { background: this.state.buttonColor } : { background: '#ddd' }}
          disabled={!(this.props.valid) || this.props.submitting || this.state.buttonColor === '#ddd'}
          type="submit">{(this.state.buttonColor === '#ddd') ? 'Please wait...' : 'Save'}</Button>
      </div>
    </Form >);

    let tableProgress = <div align="center"><CircularProgress size={75} /></div>;

    if (!this.props.data.report_types.fetching && !this.props.data.billingInfo.fetching &&
      this.props.data.report_types.fetched && this.props.data.billingInfo.fetched) {
      tableProgress = form;
    }


    return (
      <Layout
        className="App"
        showMenu
        menuTitle=""
        toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
      >
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Changes saved</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Your changes have been saved.  Do you wish to modify another report?
          </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseYes} color="primary">
              Yes
          </Button>
            <Button onClick={this.handleCloseNo} color="primary" autoFocus>
              No
          </Button>
          </DialogActions>
        </Dialog>
        <Prompt
          when={!this.state.formSaved && this.props.isDirty}
          message="Any changes will be lost if you leave this screen. Would you like to continue?"
        />
        <Paper className={classes.paperStyle}>
          <AppBar position="static" className={classes.headerStyle}>
            <Toolbar className={classes.headerTitleStyle}>
              <Typography variant="title" className="lightH2">
                {(this.props.match.params.id) ? 'Edit Billing Information' : 'Add Billing Information'}
              </Typography>
              <IconButton title="close" component={Link} to="/customers">
                <Close color="disabled" />
              </IconButton>
            </Toolbar>
          </AppBar>
          {tableProgress}
        </Paper>
      </Layout>
    );
  }
}

AddEditBillingInformation.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = (state, ownProps) => ({
  data: {
    config: state.config.config,
    report_types: state.reportTypes,
    billingInfo: state.search
  },
  isDirty: isDirty('AddEditBillingInformationForm')(state)
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getReportTypes: (config, self) => {
      dispatch(getReportTypes(config, self)).then((reports) => {
        const reportData = reports.value.data.reportTypes.map(report => ({ displayName: report.displayName, enum: report.reportTypeId, methodId: report.methodId }));
        self.setState({ reports: reportData });
      });
    },
    getCustomerBillingInfo: (key, config, self) => {
      // search is used here to populate customer name. A customer won't be in the store if it was just created.
      dispatch(search('customers', 0, 'customerId', key, config, self)).then((result) => {
        const { data } = result.value;
        const customer = data.items.find(item => key === item.customerId);
        const customerReports = [];

        customer.authorizedMethodIds.map((custReports) => {
          customerReports.push(custReports);
        });

        self.setState({ reportNames: customerReports });
        self.setState({ customerName: customer.name });
        self.setState({ vhrOwnership: customer.vhrOwnership });

      });
      dispatch(search('contract-rates', 0, 'customerId', key, config)).then((billingInformation) => {
        const billingInfos = billingInformation.value.data.items;
        if (billingInfos.length > 0) {
          const dt = new Date();
          billingInfos.filter(e => new Date(e.startDate) < dt && dt < (e.hasOwnProperty('endDate') ? new Date(e.endDate)
            : new Date('12/31/9999')))
            .map((billingInfo) => {
              if (billingInfo.reportTypeId !== '16d4becc-e3ac-4f15-9dd2-159b74dd763c') {
                self.setState({ showOwnership: true });
              } else {
                self.setState({ showOwnership: false });
              }
              billingInfo.startDate = (billingInfo.startDate) ? new Date(billingInfo.startDate).toISOString().split('T')[0] : '';
              billingInfo.endDate = (billingInfo.endDate) && billingInfo.endDate !== '12/31/9999' && billingInfo.endDate !== '9999-12-31' ? new Date(billingInfo.endDate).toISOString().split('T')[0] : '';
              billingInfo.billInvalidVINs = billingInfo.billInvalidVINs ? 'Yes' : 'No';
              billingInfo.billNoHistory = billingInfo.billNoHistory ? 'Yes' : 'No';
              billingInfo.billNoHits = billingInfo.billNoHits ? 'Yes' : 'No';
              self.props.initialize(billingInfo);
              self.setState({ contractRateId: billingInfo.contractRateId });
              self.props.change('billingRate', Number.parseFloat(billingInfo.billingRate * 1.00).toFixed(2).toString());
              self.props.change('reportTypeMin', (billingInfo.reportTypeMin) ? Number.parseFloat(billingInfo.reportTypeMin * 1.00).toFixed(2).toString() : '');
              self.props.change('reportTypeMax', (billingInfo.reportTypeMax) ? Number.parseFloat(billingInfo.reportTypeMax * 1.00).toFixed(2) : '');
              self.setState({ reportSelected: billingInfo.reportTypeId });
            });
        } else {
          self.props.dispatch(change('AddEditBillingInformationForm', 'billInvalidVINs', 'Yes'));
          self.props.dispatch(change('AddEditBillingInformationForm', 'reportWithOwnership', 'No'));
          self.props.dispatch(change('AddEditBillingInformationForm', 'billNoHits', 'No'));
          self.props.dispatch(change('AddEditBillingInformationForm', 'billNoHistory', 'Yes'));
          self.setState({ contractRateId: '' });
        }
      });
    },
    addEditBillingInformation: (billingInformation, config, self) => {
      dispatch(addEditBillingInformation(billingInformation, config)).then((o) => {
        if (o.action.type === 'ADD_EDIT_BILLING_INFORMATION_SAVE_FULFILLED') {
          self.setState({ open: true, buttonColor: '#002053', formSaved: true });
        }
      });
    }
  }
});

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'AddEditBillingInformationForm',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  validate
})(AddEditBillingInformation));

const ConnectedAddEditBillingInformation = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxForm);

export default ConnectedAddEditBillingInformation;


// WEBPACK FOOTER //
// ./src/components/Customer/BillingRate/AddEditBillingInformation.js